var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2898",
    space: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    svg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2902"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2912"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path2910"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2904",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2906"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2908",
    clipPath: "url(#clipPath2912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2914",
    transform: "translate(100.8027,364.4932)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -30.926,-250.235 c -1.349,-10.914 -10.712,-19.139 -21.667,-18.181 -11.058,0.968 -18.742,10.79 -18.181,21.667 l 12.725,246.551",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2916"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2918",
    transform: "translate(411.292,363.7246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 30.831,-249.467 c 1.349,-10.914 10.711,-19.138 21.667,-18.18 11.058,0.967 18.742,10.79 18.181,21.667 L 57.957,0.519",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2920"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2922",
    transform: "translate(165.0005,416.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 h 312 c 13.75,0 25,-11.25 25,-25 v -0.001 C 337,-38.751 325.75,-50 312,-50 h -442.001 c -13.75,0 -25,11.249 -25,24.999 V -25 c 0,13.75 11.25,25 25,25 H -90",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2924"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2926",
    transform: "translate(97.8892,326)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 316.222",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 22.926,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2928"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2930",
    transform: "translate(119.9966,416.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 0.007",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 2.613,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2932"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideTable);
export default __webpack_public_path__ + "static/media/sideTable.9aaafeb68a87e7a20504ea06e5b5b58c.svg";
export { ForwardRef as ReactComponent };